<template>
  <v-dialog v-model="isShow" persistent width="600">
    <v-overlay :value="isLoading">
      <v-progress-circular
        color="primary"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>UPLOAD</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <div class="mt-5">
        <v-row style="width: 95%" class="ml-3 mt-1">
          <v-text-field v-model="name" label="Group Name"></v-text-field>  
        </v-row>
        <v-row style="width: 95%" class="ml-2 mt-2">
          <v-col cols="9" lg="9" md="9" sm="9" style="padding: 0px 10px">
            <v-file-input
              label="Data File"
              outlined
              dense
              v-model="uploadFile"
              accept=".xlsx"
            ></v-file-input>
          </v-col>
          <v-col cols="1" lg="1" md="1" sm="1" style="padding: 2px 10px">
            <v-btn
              color="primary"
              outlined
              @click="upload"
              :disabled="!this.uploadFile"
              >Upload</v-btn
            >
          </v-col>
        </v-row>
        <v-row style="width: 95%" class="ml-2 mt-2">
          <v-col cols="12" style="text-align: start">
            <a class="ml-2" :href="url">Download Sample XLSX File</a>
          </v-col>
        </v-row>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { userService } from "@/api/user-service";

export default {
  name: "uploadGroupModal",
  props: { isShow: Boolean, id: String },
  data: () => {
    return {
      uploadFile: "",
      isLoading: false,
      type: "GROUPMEMBERS",
      name: "",
    };
  },
  computed: {
    url() {
      return this.type + "_sample.xlsx";
    },
  },
  watch:{
    id(val){
      this.name = val
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async upload() {
      if (!this.id && !this.name)
        return;
      let formData = new FormData();
      formData.append("files[]", this.uploadFile);
      let payload = { identity: "", file: formData };
      this.isLoading = true;
      if (this.id)
      {
        this.name = this.id
      }
      let result = await userService.uploadFile(this.name, payload);

      this.isLoading = false;
      if (result != "ERROR") {
        alert("Imported Successfully");
        this.$emit("completed");
      } else alert("Failed to Import, try again");
    },
  },
};
</script>

<style>
</style>